import React, { useEffect, useRef, useState } from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
// import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
// import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import CommentSection from "./CommentSection";
import defaultUserProfile from "../../assets/defaultUserProfile.jpeg";
import FifaCard from "../Avatar/Avatar";
import { BadgeCheck } from 'lucide-react'; 


import "../../component/post/post.css";
import { Link } from "react-router-dom";

const PostCard = ({ post, user, token, toggleLike, getPosts }) => {
  const [showLikesModal, setShowLikesModal] = useState(false);
  const [showAvatarPreview, setShowAvatarPreview] = useState(false);
  const [avatarTop, setAvatarTop] = useState(0);
  const postImgRef = useRef(null);

  const updateAvatarPosition = () => {
    if (postImgRef.current) {
      const rect = postImgRef.current.getBoundingClientRect();
      const top = window.scrollY + rect.top * 0.1;
      setAvatarTop(top);
    }
  };

  // console.log(66666);
  // console.log(post);
  
  useEffect(() => {
    if (showAvatarPreview) {
      window.addEventListener("scroll", updateAvatarPosition);
      updateAvatarPosition(); 
    }
    return () => {
      window.removeEventListener("scroll", updateAvatarPosition);
    };
  }, [showAvatarPreview]);



  return (
    <div className="post">
      {/* user info */}
      <div className="postInfo">
         <Link to={`/profile/${post.user?.hashed_id}/${post.user?.username}`} >
        
          <img
            ref={postImgRef}
            className="postInfoImg"
            src={
              post.user.avatar
                ? `https://dashboard.tiktaka.com/${post.user.avatar}`
                : defaultUserProfile
            }
            onMouseEnter={() => setShowAvatarPreview(true)}
            onMouseLeave={() => setShowAvatarPreview(false)}
            alt='profile'
          />
        </Link>
        

      <div className="postInfousername" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {post.user.name} 
          
          {post.user.is_admin === 1 && (
            <BadgeCheck size={22} color="#1d9bf0" fill="#1d9bf0" stroke="white" />
          )}
      </div>

        <div className="timingInfo">
            {new Date(post.created_at).toLocaleString('en-US', {
              // weekday: 'short',  // Thu
              year: 'numeric',   // 2025
              month: 'short',    // Aug
              day: 'numeric',    // 23
              hour: '2-digit',
              minute: '2-digit'
            })}
        </div>
      </div>

      {/* post content */}
      <div className="postImg">
        {post.type === "image" ? (
          <img
            className="postImgDone"
            src={`https://dashboard.tiktaka.com/${post.post}`}
            alt="post img"
          />
        ) : post.type === "reel" ? (
          <video
            controls
            autoPlay
            muted
            loop
            // controlsList="nodownload"
            width="400"
            className="postVideo"
          >
            <source
              src={post.post && `https://dashboard.tiktaka.com/${post.post}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <p className="postText">{post.post}</p>
        )}

          {showAvatarPreview && (
              <div
                className="avatarPreview"
                style={{ top: avatarTop, left: "12%" }}
              >
              <FifaCard
                name={post.user.name || "Player"}
                fav_number={post.user.fav_number || ""}
                foot={post.user.foot || ""}
                position={post.user.position || ""}
                profilePicture={
                  post.user.avatar && post.user.avatar.includes('original_') 
                    ? `https://dashboard.tiktaka.com/${post.user.avatar.replace('original_', 'no_bg_')}` 
                    : post.user.avatar 
                      ? `https://dashboard.tiktaka.com/${post.user.avatar}`
                      : ''
                }
                omitBackground={true}


              />
            </div>
          )}
      </div>

      {/* actions */}
      <div className="iconsBlock">
        <div className="leftIcons">
          {/* Like */}
          <button className="commentPostBtn" onClick={() => toggleLike(post.id)}>
            {post.reacts.some((react) => react.user_id === (user && user.id)) ? (
              <FavoriteIcon sx={{ fontSize: "30px", color: "red" }} />
            ) : (
              <FavoriteBorderIcon sx={{ fontSize: "30px" }} />
            )}
          </button>

          {/* Comment */}
          <button className="commentPostBtn">
            <ModeCommentOutlinedIcon sx={{ fontSize: "30px" }} />
          </button>

          {/* Share */}
          {/* <button className="sharePostBtn">
            <SendOutlinedIcon sx={{ fontSize: "30px" }} />
          </button> */}
        </div>

        <div>
          {/* Save */}
          {/* <button className="savePostBtn">
            <BookmarkBorderOutlinedIcon sx={{ fontSize: "30px" }} />
          </button> */}
        </div>
      </div>

      {/* likes */}
      <div className="likeSection">
        <div className="imagesLike">
          {post.reacts.slice(0, 2).map((react, idx) => (
            <img
              key={react.id}
              className="likeImg"
              style={{ zIndex: 10 - idx }}
              src={
                react.user.avatar
                  ? `https://dashboard.tiktaka.com/${react.user.avatar}`
                  : defaultUserProfile
              }
              alt=""
            />
          ))}
        </div>

        <div
          className="noOfLikes"
          onClick={() => setShowLikesModal(true)} 
        >
          {post.reacts.length} Likes
        </div>
      </div>

      {/* caption */}
      <div className="postAbout">
        <div className="infoComment">{post.title}</div>
      </div>

      {/* comments */}
      <CommentSection
        comments={post.comments}
        postId={post.id}
        token={token}
        user={user}
        onCommentAdded={getPosts}
      />

      {/* Likes Modal */}
      {showLikesModal && (
        <div className="likesModal">
          <div className="likesModalContent">
            <h3>Liked by</h3>
            <button
              className="closeModal"
              onClick={() => setShowLikesModal(false)}
            >
              ✖
            </button>

            {post.reacts.length > 0 ? (
              post.reacts.map((react) => (
                <div key={react.id} className="likeUser">
                  <img
                    src={
                      react.user.avatar
                        ? `https://dashboard.tiktaka.com/${react.user.avatar}`
                        : defaultUserProfile
                    }
                    alt={react.user.name}
                    className="likeUserImg"
                  />
                  <span>{react.user.name}</span>
                </div>
              ))
            ) : (
              <p>No likes yet</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PostCard;
